module.exports = __webpack_public_path__ + "img/xcl.bc20b085.png";